import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import SocialIcon from "./SocialIcon";


function SocialIcons(props) {
  const {smItems, classes, className} = props;

  const links = smItems.map(smlink => smlink.link);

  return (
    <React.Fragment>
      <ul className={`${classes.container} ${className}`}>
        {smItems.map((smlink, index) => (
          <li key={index} className={classes.item}>
            <SocialIcon link={smlink.link} iconUrl={smlink.iconUrl}/>
          </li>
        ))}
      </ul>
      <script type="application/ld+json">
        {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "Gridhaus",
          "url": "http://www.gridhaus.com",
          "sameAs": ["${links.join('","')}"]
        }`}
      </script>
    </React.Fragment>
  );
}


export default withStyles(theme => ({
  container: {
    display: 'flex',
    margin: -6,
  },
  item: {
    margin: 6,
  },
}))(SocialIcons);


// WEBPACK FOOTER //
// ./src/parts/SocialIcons.js